import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { getUsePrimaryUrlParams } from "../../utils/utils";
import { ISchema } from "clients/LaForgeClient/validation-types/SchemaDefinition";

export const updateCustomerAccountUpdatedWebhook = (axios: IAxiosInstance) => {
  return async ({
    customerAccountUpdatedWebhook,
    userType,
    isTestWebhookType,
    usePrimary,
  }: ISchema["#/definitions/IUpdateCustomerAccountUpdatedWebhookArgs"]) => {
    const response = await axios.noRetry.post<
      ISchema["#/definitions/IUpdateCustomerAccountUpdatedWebhookResponse"]
    >(
      `/api/updateCustomerAccountUpdatedWebhook${getUsePrimaryUrlParams(
        usePrimary
      )}`,
      {
        customer_account_update_webhook: customerAccountUpdatedWebhook,
        user_type: userType,
        is_test_webhook_type: isTestWebhookType,
      }
    );

    const { data: responseData } = response;
    if (!responseData.success) {
      throw new Error(`Something went wrong`);
    }
    return responseData;
  };
};
